export default {
    areaLine: {
        grid: {
            show: false,
            top: 0,
            left: 0,
            reight: 0,
            bottom: 0,
            width: '100%'
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            show: false
        },
        yAxis: {
            type: 'value',
            show: false
        },
        series: [{
            data: [],
            type: 'line',
            areaStyle: {}
        }]
    }
};